module.exports = __webpack_public_path__ + "static/img/join_img2.db694575.jpeg";